module.exports = __webpack_public_path__ + "files/1ed46460f6c9423edc02977463bbba40.svg";